<template>
  <ng-table
    class="ng-table"
    :columns="columns"
    :params="params"
    :rowKey="row => row.batch_id"
    :request="$axios.Enterlibrary_doneServeList"
    :load.sync="loadTable"
    :reload.sync="reloadTable"
    :scroll="{y: scrollyHeight - 20}"
  >
    <!-- 头像 -->
    <template slot="lib_logo_url" slot-scope="text, scope">
      <ng-image
        class="table-header"
        :src="scope.lib_logo_url ? `${scope.lib_logo_url}?x-oss-process=style/thumb_10` : $var.defaultHeader"
        @error="({target}) => target.src = $var.defaultHeader"
      />
    </template>

    <template slot="number" slot-scope="text">
      <span>{{`批次${text}`}}</span>
    </template>

    <template slot="charger_names" slot-scope="text">
      <template v-if="text">
        <div v-for="(item, index) in text.split('、')" :key="index">{{item}}</div>
      </template>
    </template>

    <template slot="operation" slot-scope="text, scope">
      <a-button
        v-if="$root.$checkAuth($auth[authName] && $auth[authName].goTag)"
        class="m-right-ms"
        type="link"
        @click="goTag(scope)"
        :disabled="!scope.op_tag"
      >发起标注</a-button>
    </template>
  </ng-table>
</template>

<script>
  import {tableMixins} from '@/mixins';

  import * as TabCol from '@/config/columns';

  const columns = [
    TabCol.colId,
    TabCol.portrait('封面', 'lib_logo_url'),
    TabCol.commonKey('曲库名称', 'lib_name', {ellipsis: true}),
    TabCol.commonKey('曲库简称', 'lib_short_name'),
    TabCol.commonKey('所属供应商', 'suplr_name', {ellipsis: true}),

    TabCol.commonKey('入库批次', 'number', '', true),
    TabCol.commonKey('认领人', 'charger_names', '', true),
    TabCol.operation('100px')
  ]

  export default {
    data() {
      return {
        columns,
        tableList: [],
        // params: {},
      }
    },

    props: {
      authName: String,
      scrollyHeight: {
        type: Number,
        default: 400
      },
      params:Object
    },

    mounted() {
      // this.params = {page: this.$route.query.page || 1};
    },

    mixins: [
      tableMixins
    ],

    methods: {
      goTag(scope) {
        let vm = this;

        this.$confirm({
          width: '480px',
          title: '确认要发起标注吗？',
          onOk() {
            return new Promise((resolve, reject) => {
              vm.cofirmTag(scope, resolve, reject);
            });
          }
        });
      },

      cofirmTag(scope, next, reject) {
        this.$axios.Enterlibrary_goRemark({batch_id: scope.batch_id}).then(res => {
          const data = res.data;

          if (data && data.code == 0) {
            this.$message.success('发起标注成功');
            next();

            setTimeout(() => {
              this.loadTableData();
            }, 500);
          } else {
            reject()
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .ant-table td {
    white-space: nowrap;
  }
</style>
